import React from 'react'
import { Div, Strong } from '@driftt/tide-core'

const SegmentProperty = ({ propertyDef, onClick }) => {
  return (
    <Div className="filter-builder--filter-property" onClick={onClick}>
      <Strong>
        <Div className="filter-builder--filter-property--truncated">
          {propertyDef.type === 'PLAYBOOK' ? propertyDef.label : propertyDef.displayName}
        </Div>
      </Strong>
    </Div>
  )
}

export default SegmentProperty
